var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-card',{staticClass:"pa-3",attrs:{"id":"info-links-page"}},[(_vm.selectAppSettingLoading)?_c('v-skeleton-loader',{attrs:{"height":"100px","type":"image"}}):_vm._e(),(!_vm.selectAppSettingLoading)?_c('div',{staticClass:"tip-tap-content",domProps:{"innerHTML":_vm._s(_vm.model.option_value)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }